import './bootstrap'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import "./assets/scss/app.scss";

Vue.config.productionTip = false

const createApp = async () => {
  await store.dispatch('auth/loginCheck')
  new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
  }).$mount('#app')
}

createApp()